// Global image preloader to prevent multiple requests
class ImagePreloader {
  constructor() {
    this.cache = new Map();
    this.loading = new Set();
    this.loaded = new Set();
  }

  async preloadImage(src) {
    // If already loaded, return immediately
    if (this.loaded.has(src)) {
      return Promise.resolve();
    }

    // If already loading, return the existing promise
    if (this.loading.has(src)) {
      return this.cache.get(src);
    }

    // If cached, return the cached promise
    if (this.cache.has(src)) {
      return this.cache.get(src);
    }

    // Create new loading promise
    const promise = new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        this.loaded.add(src);
        this.loading.delete(src);
        resolve();
      };
      img.onerror = () => {
        this.loading.delete(src);
        reject(new Error(`Failed to load image: ${src}`));
      };
      img.src = src;
    });

    this.loading.add(src);
    this.cache.set(src, promise);
    return promise;
  }

  async preloadImages(srcs) {
    const promises = srcs.map(src => this.preloadImage(src));
    return Promise.allSettled(promises);
  }

  isLoaded(src) {
    return this.loaded.has(src);
  }

  isLoading(src) {
    return this.loading.has(src);
  }
}

// Global instance
const imagePreloader = new ImagePreloader();

export default imagePreloader;
